import clsx from "clsx";

export function BulletSteps({
	steps,
	selectedIndex,
	navRef,
}: {
	steps: Record<string, any>;
	selectedIndex: number;
	navRef?: boolean;
}) {
	return (
		<nav
			className={clsx(
				navRef ? "yF-mb-3" : "yF-mb-0",
				"yF-text-[--yF-theme-accent] yF-flex yF-items-center yF-justify-center",
			)}
			aria-label="Progress"
		>
			{steps.map((step: any) => (
				<p
					key={step.id}
					className="!yF-pb-0 yF-text-[--theme-accent] yF-text-md yF-font-medium yF-leading-4"
				>
					{step.id < selectedIndex ? "" : step.id === selectedIndex ? step.name : ""}
				</p>
			))}
			<ol
				role="list"
				className="!yF-mb-0 yF-ml-5 yF-mr-5 yF-flex yF-items-center yF-space-x-3 sm:yF-space-x-5 sm:yF-ml-8"
			>
				{steps.map((step: any) => (
					<li key={step.id} className="!yF-list-none !yF-pb-0">
						{step.id < selectedIndex ? (
							<button
								className="yF-block yF-h-2.5 yF-w-2.5 yF-rounded-full yF-bg-[--yF-theme-color] yF-hover:bg-[--yF-hover-color]"
								aria-label={step.name}
							>
								<span className="yF-sr-only"></span>
							</button>
						) : step.id === selectedIndex ? (
							<button
								className="yF-relative yF-flex yF-items-center yF-justify-center"
								aria-label={step.name}
								aria-current="step"
							>
								<span
									className="yF-absolute yF-flex yF-h-5 yF-w-5 yF-p-px"
									aria-hidden="true"
								>
									<span className="yF-h-full yF-w-full yF-rounded-full yF-bg-[--yF-bullet-bg]" />
								</span>
								<span
									className="yF-relative yF-block yF-h-2.5 yF-w-2.5 yF-rounded-full yF-bg-[--yF-theme-color]"
									aria-hidden="true"
								/>
								<span className="yF-sr-only"></span>
							</button>
						) : (
							<button
								className="yF-block yF-h-2.5 yF-w-2.5 yF-rounded-full yF-bg-gray-200 hover:yF-bg-gray-400"
								aria-label={step.name}
							>
								<span className="yF-sr-only"></span>
							</button>
						)}
					</li>
				))}
			</ol>
		</nav>
	);
}
